import { Lead } from './lead.model';
import { RequestMotivationEnum } from './requests/createLeadRequest.model';

export interface QuoteRequestAssignment {
  id: number;
  quoteRequest: QuoteRequest;
  assignetAt: string;
}

export interface QuoteRequest {
  id: number;
  lead?: Lead;
  country?: string;
  region?: string;
  district?: string;
  requestStatus: OfferRequestStatusEnum;
  dentalArch: DentalArch;
  treatmentType: TreatmentType;
  createdAt: string;
  /** Valorizzato se il paziente ha sospeso la ricezione di altri preventivi su questa richiesta (toggle area paziente). */
  suspendedAt?: string;
  requestMotivation: RequestMotivationEnum;
  requestDetails?: string;
  panoramicPhoto1: string;
  panoramicPhoto2: string;
  panoramicPhoto1UrlOriginal: string;
  panoramicPhoto2UrlOriginal: string;
  panoramicPhoto1UrlLarge: string;
  panoramicPhoto2UrlLarge: string;
  panoramicPhoto1UrlMedium: string;
  panoramicPhoto2UrlMedium: string;
  panoramicPhoto1UrlThumb: string;
  panoramicPhoto2UrlThumb: string;
  otherImagesUrlOriginal: string[];
  otherImagesUrlLarge: string[];
  otherImagesUrlMedium: string[];
  otherImagesUrlThumb: string[];
  otherImages: string[];
  panoramicPhotoCount?: number;
  otherImagesCount?: number;
  healthDataRestricted?: boolean;
}

export enum DentalArch {
  UPPER = 'UPPER',
  LOWER = 'LOWER',
  BOTH = 'BOTH',
}

export enum TreatmentType {
  NECESSARY = 'NECESSARY',
  TOTAL = 'TOTAL',
}

export enum OfferRequestStatusEnum {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  SUSPENDED = 'SUSPENDED',
  CANCELLED = 'CANCELLED',
  QUOTE_ISSUED = 'QUOTE_ISSUED'
}
